import React from 'react';
import styled from 'styled-components';
import { ShadowTheme } from '../../../components/globaStyledComponents/globalStyledComponentsStyling';

const ZoomControlsContainer = styled.div`
    position: absolute;
    right: 24px;
    top: 24px;
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(16px);
    border-radius: 100px;
    box-shadow: ${ShadowTheme.shadow_200.boxShadow};
    width: 44px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.3);
`;

const ZoomButton = styled.button`
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: all 0.2s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.2);
    }

    &:active {
        background-color: rgba(255, 255, 255, 0.3);
    }

    svg {
        width: 24px;
        height: 24px;
    }
`;

const Divider = styled.div`
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    width: 100%;
`;

interface CustomZoomControlsProps {
    onZoomIn: () => void;
    onZoomOut: () => void;
}

const CustomZoomControls: React.FC<CustomZoomControlsProps> = ({ onZoomIn, onZoomOut }) => {
    return (
        <ZoomControlsContainer>
            <ZoomButton onClick={onZoomIn} aria-label="Zoom in">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 5V15" stroke="#222222" strokeWidth="1.6" strokeLinecap="round"/>
                    <path d="M15 10L5 10" stroke="#222222" strokeWidth="1.6" strokeLinecap="round"/>
                </svg>
            </ZoomButton>
            <Divider />
            <ZoomButton onClick={onZoomOut} aria-label="Zoom out">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 10L5 10" stroke="#222222" strokeWidth="1.6" strokeLinecap="round"/>
                </svg>
            </ZoomButton>
        </ZoomControlsContainer>
    );
};

export default CustomZoomControls; 